import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./style/MediaTab.module.css";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Nav,
  Row,
  Tab,
} from "react-bootstrap";
import clsx from "clsx";
import { ImageUploader, TabTitle, VideoUploader } from "@components";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { editingCourseActions, updateCourseAction } from "@redux/actions";
import { uploadAPI } from "@services/api/upload/upload";
import { UploadedItem } from "@components/UploadedItem";
import { CourseContext } from "..";
import { uploadImage } from "@helpers";
import { DEFAULT_IMAGE_SRC_169 } from "@constants";

const MediaTab = () => {
  const dispatch = useDispatch();
  const { step, setStep, isUpdate, autoSave, setAutoSave } =
    useContext(CourseContext);

  const validateSchema = Yup.object().shape({
    thumbnailUrl: Yup.string().required("Thumbnail is required"),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    setValues,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      externalURL: "",
      // youtubeURL: "",
      // vimeoURL: "",
      // embededCode: "",
      thumbnailUrl: "",
      previewVideoUrl: "",
    },
    validationSchema: validateSchema,
    onSubmit: (values) => {
      handleSaveChange();
      setStep(step + 1);
    },
  });

  const editingCourse = useSelector((state) => state.course.editingCourse);

  useEffect(() => {
    if (isUpdate) {
      setFieldValue("externalURL", editingCourse.previewVideoUrl);
      setFieldValue("previewVideoUrl", editingCourse.previewVideoUrl);
      setFieldValue("thumbnailUrl", editingCourse.thumbnailUrl);
      console.log(editingCourse);
    }
  }, [isUpdate, editingCourse]);

  function handleUploadThumbnail({ src, name, type }) {
    setFieldValue("thumbnailUrl", src);
  }

  function handleUploadPreviewVideo({ src, duration, name, type }) {
    setFieldValue("previewVideoUrl", src);

    // const file = event.target.files[0];
    // setFieldValue("previewVideo", file);
    // let media = new Audio(file);
    // media.onloadedmetadata = function () {
    //   console.log(media.duration); // this would give duration of the video/audio file
    // };
    // const link = URL.createObjectURL(file);
    // console.log(link);
  }

  function handleThumbnailPreview() {
    // if (values.thumbnailImg) {
    //   return URL.createObjectURL(values.thumbnailImg);
    // } else
    if (values.thumbnailUrl) {
      return values.thumbnailUrl;
    } else {
      return DEFAULT_IMAGE_SRC_169;
    }
  }

  const handleSaveChange = async () => {
    await dispatch(editingCourseActions.changeMediaInfo(values));
    dispatch(updateCourseAction());
  };

  return (
    <Container>
      <TabTitle
        onSave={handleSaveChange}
        isAutoSave={autoSave}
        setAutoSave={setAutoSave}
      >
        <i className="bi bi-plus-square mr-2"></i>Media
      </TabTitle>
      <h6>Intro Course overview video and thumbnail</h6>
      <div className={clsx(styles.tabChildContainer, " mb-4 mt-3")}>
        <Tab.Container defaultActiveKey="1">
          {/* <Nav variant="pills" className="justify-content-center gap-3 mb-4">
            <Nav.Item>
              <Nav.Link eventKey="1">HTML5 mp4</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="2">External Url</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link eventKey="3">Youtube</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="4">Vimeo</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="5">Embeded</Nav.Link>
              </Nav.Item> 
          </Nav> */}
          <Row className="">
            <Col lg={6} className={"mb-3"}>
              <Tab.Content>
                <Tab.Pane eventKey="1">
                  <div className="bg-white">
                    <VideoUploader
                      error={touched.previewVideoUrl && errors.previewVideoUrl}
                      onUploadFinish={handleUploadPreviewVideo}
                      src={values.previewVideoUrl}
                    />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
            <Col lg={6}>
              {/* <h6>Course    *</h6> */}
              <div className="bg-white">
                <ImageUploader
                  onUploadFinish={handleUploadThumbnail}
                  error={touched.thumbnailUrl && errors.thumbnailUrl}
                  src={values.thumbnailUrl}
                />
              </div>
            </Col>
          </Row>
        </Tab.Container>
      </div>

      <div className=" d-flex justify-content-between mt-5">
        <Button
          onClick={() => {
            setStep(step - 1);
          }}
          disabled={step == 1 ? true : false}
        >
          Prev
        </Button>

        <Button type="submit" onClick={handleSubmit}>
          Next
        </Button>
      </div>
    </Container>
  );
};

/* required: display name */
MediaTab.displayName = "MediaTab";

/* required: props types */
MediaTab.propTypes = {};

/* required: default props */
MediaTab.defaultProps = {};

export { MediaTab };
